/**
 * Small UI copy constants that are product-owned (not CMS) and reused across
 * sell / dashboard feature sections.
 */
export const ELITE_PRIME_FEATURES_ELITE_BUNDLE_LABEL = 'Also get everything in Elite :'
export const ELITE_PRIME_DASHBOARD_FEATURES_ELITE_BUNDLE_LABEL = 'Features you enjoy in Elite :'
export const ELITE_PRIME_DASHBOARD_BADGE = 'Upgraded tier of Elite'
